import { useRouter } from "next/router";
import { SetStateAction, useCallback } from "react";

export function useSearchParam(name: string, defaultValue: string | null = null) {
  const router = useRouter();

  const url = getCurrentUrl();
  let value = null;
  if (url) {
    value = url.searchParams.get(name) ?? defaultValue;
  }

  const setValue = useCallback(
    async (
      newValue: SetStateAction<string | null>,
      currentUrl?: URL
    ): Promise<{ changed: boolean; currentUrl?: URL }> => {
      const oldUrl = currentUrl ?? getCurrentUrl();

      const c = oldUrl?.searchParams?.get(name) ?? defaultValue;
      const n = typeof newValue === "function" ? newValue(c) : newValue;

      const newUrl = oldUrl && new URL(oldUrl);
      if (n == null || n === defaultValue) newUrl?.searchParams?.delete(name);
      else newUrl?.searchParams?.set(name, n);

      const changed = oldUrl?.toString() !== newUrl?.toString();

      if (changed && newUrl) {
        await router?.replace?.(newUrl, undefined, { shallow: true });
      }

      return { changed, currentUrl: newUrl };
    },
    [router, name, defaultValue]
  );

  return [value, setValue] as [string, typeof setValue];
}

export function getCurrentUrl() {
  if (typeof window === "undefined") return undefined;
  return new URL(window.location.href);
}
